function redirectAutoFromIp() {
	let countryCode = document.querySelector("body").dataset.country;
  console.log('test', countryCode);

	const currentUrl = window.location.href;

  if (currentUrl.includes("redirect=false") || currentUrl.includes("oseid")) {
		sessionStorage.setItem("no_redirect", "true");
  }
  if (sessionStorage.getItem("no_redirect") == "true" || countryCode === " ") {
		// Do not redirect
  } else {

    //Mis en commentaire antoine 22.01.2026//
    // Redirect
    //if (countryCode == "ES") {
      //window.location.href = "https://shapeheart.es/"; // 07/09/2026 : domaine de marché (www.shapeheart.es = legacy), bloc toujours inactif
    //}
    // Correctif 12.06.2026 : le "} else if" orphelin laissé lors de la mise en
    // commentaire du bloc ES rendait tout le fichier syntaxiquement invalide :
    // le script ne s'exécutait plus du tout (redirection CH morte depuis le 22.01.2026).
    if (countryCode == 'CH') {
      window.location.href = "https://shapeheart.ch/";
    }
  }
}
redirectAutoFromIp()
